/**
 * Canonical RP consent group names for `data-consent-group` (mirrors App\Constants\ConsentConstants).
 */

/** @typedef {'essential'|'functional'|'performance'|'targeting'} ConsentGroup */

export const CONSENT_GROUP_ESSENTIAL = 'essential';
export const CONSENT_GROUP_FUNCTIONAL = 'functional';
export const CONSENT_GROUP_PERFORMANCE = 'performance';
export const CONSENT_GROUP_TARGETING = 'targeting';

/** @type {readonly ConsentGroup[]} */
export const CONSENT_GROUPS = [
	CONSENT_GROUP_ESSENTIAL,
	CONSENT_GROUP_FUNCTIONAL,
	CONSENT_GROUP_PERFORMANCE,
	CONSENT_GROUP_TARGETING,
];
